import fetch from "isomorphic-fetch"
import Client from "shopify-buy"
import { isBrowser } from "../lib"
import Cookie from "js-cookie"

const SET_LOADING = "shop:set-loading"
const SET_CHECKOUT = "shop:set-checkout"
const SET_SHOP_ANNOUNCEMENT = "shop:set-announcement"
const SET_SHOP_ANNOUNCEMENT_DATA = "shop:set-announcement-data"

const COOKIE_ID = "rad_shopify_checkout_id"

const client = Client.buildClient(
  {
    storefrontAccessToken: process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
    domain: `${process.env.GATSBY_SHOP_NAME}.myshopify.com`,
  },
  fetch
)

const initialState = {
  client,
  loading: false,
  checkout: { lineItems: [] },
  showShopAnnouncementBar: false,
  shopAnnouncementData: null,
  products: [],
  shop: {},
}

const createNewCheckout = shop => shop.client.checkout.create()
const fetchCheckout = (shop, id) => shop.client.checkout.fetch(id)

export const initializeCheckout = () => async (dispatch, getState) => {
  const existingCheckoutId = isBrowser() ? Cookie.get(COOKIE_ID) : null
  const { shop } = getState()

  if (existingCheckoutId) {
    try {
      const checkout = await fetchCheckout(shop, existingCheckoutId)
      if (!checkout.completedAt) {
        dispatch(setCheckout(checkout))
        return
      }
    } catch (e) {
      Cookie.set(COOKIE_ID, null)
    }
  }
  const newCheckout = await createNewCheckout(shop)
  Cookie.set(COOKIE_ID, newCheckout.id)
  dispatch(setCheckout(newCheckout))
}

export const updateLineItem = (lineItemId, quantity) => async (
  dispatch,
  getState
) => {
  dispatch(setLoading(true))
  const { checkout, client } = getState().shop
  const lineItemsToUpdate = [
    {
      id: lineItemId,
      quantity: parseInt(quantity, 10),
    },
  ]

  const updatedCheckout = await client.checkout.updateLineItems(
    checkout.id,
    lineItemsToUpdate
  )

  if (updatedCheckout.lineItems.length === 0) {
    dispatch(setShopAnnouncementBarVisibility(false))
  }

  dispatch(setCheckout(updatedCheckout))
}

export const addVariantToCart = (variantId, quantity, title) => async (
  dispatch,
  getState
) => {
  if (variantId === "" || !quantity) {
    console.error("Variant + Quantity Required!")
    return
  }
  dispatch(setShopAnnouncementBarData(title))
  dispatch(setLoading(true))

  const { checkout, client } = getState().shop
  const lineItemsToUpdate = [
    {
      variantId,
      quantity: parseInt(quantity, 10),
    },
  ]

  const updatedCheckout = await client.checkout.addLineItems(
    checkout.id,
    lineItemsToUpdate
  )
  dispatch(setShopAnnouncementBarVisibility(true))
  dispatch(setCheckout(updatedCheckout))
}

const setCheckout = checkout => ({
  type: SET_CHECKOUT,
  payload: checkout,
})

const setLoading = bool => ({
  type: SET_LOADING,
  payload: bool,
})

export const setShopAnnouncementBarVisibility = bool => ({
  type: SET_SHOP_ANNOUNCEMENT,
  payload: bool,
})

export const setShopAnnouncementBarData = productTitle => ({
  type: SET_SHOP_ANNOUNCEMENT_DATA,
  payload: productTitle,
})

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CHECKOUT:
      return {
        ...state,
        loading: false,
        checkout: action.payload,
      }
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      }
    case SET_SHOP_ANNOUNCEMENT:
      return {
        ...state,
        showShopAnnouncementBar: action.payload,
      }
    case SET_SHOP_ANNOUNCEMENT_DATA:
      return {
        ...state,
        shopAnnouncementData: action.payload,
      }
    default:
      return state
  }
}
